export const environment = {
    production: true,
    version: '1.0.0',
    api: `${location.protocol}//petgo.co.kr/API/api`,
    apiSignalR: `${location.protocol}//api.petnimal.co.kr/`,
    apiKey: 'f8K3mPz9Qw6rXb2Ls0VtYjHn4A1uC7eD',
    private_key: "0EHfmj1dnSsvkuHPbHgsI6p4nRk0gLjh",
    private_keyuser: "B7vR2xJk9QfL4sT1mN8wHcZp5D0aG6yE",
    KSCAT: {
        APIBaseUrl: "https://localhost:51044/api",
        VAN_CODE: "07",
        DEVICE_TYPE: "1",
        CAT_ID: "DPT0TEST03"
    },
};
